import { AxiosError } from 'axios';
import { Action } from 'redux';

import { Answer, Examination, Question } from '../_models';

export enum ExaminationActionType {
  FetchExamination = '[Examination] fetchExamination',
  FetchExaminationError = '[Examination] fetchExaminationError',
  FetchExaminationSuccess = '[Examination] fetchExaminationSuccess',
  SelectNextQuestion = '[Examination] SelectNextQuestion',
  SetAnswer = '[Examination] SetAnswer',
  ShowNextResultQuestion = '[Examination] ShowNextResultQuestion',
  ShowPreviousResultQuestion = '[Examination] ShowPreviousResultQuestion',
  ShowResult = '[Examination] ShowResult',
  ShowResultQuestion = '[Examination] ShowResultQuestion',
  StartExamination = '[Examination] StartExamination',
  StartExampleQuestion = '[Examination] StartExampleQuestion',
  StopExamination = '[Examination] StopExamination',
}

export class FetchExamination implements Action<ExaminationActionType> {
  readonly type = ExaminationActionType.FetchExamination;
}

export class FetchExaminationSuccess implements Action<ExaminationActionType> {
  readonly type = ExaminationActionType.FetchExaminationSuccess;
  constructor(public payload: { examination: Examination }) {}
}

export class FetchExaminationError implements Action<ExaminationActionType> {
  readonly type = ExaminationActionType.FetchExaminationError;
  constructor(public payload: { error: AxiosError }) {}
}

export class StartExampleQuestion implements Action<ExaminationActionType> {
  readonly type = ExaminationActionType.StartExampleQuestion;
}

export class StartExamination implements Action<ExaminationActionType> {
  readonly type = ExaminationActionType.StartExamination;
}

export class SelectNextQuestion implements Action<ExaminationActionType> {
  readonly type = ExaminationActionType.SelectNextQuestion;
}

export class ShowNextResultQuestion implements Action<ExaminationActionType> {
  readonly type = ExaminationActionType.ShowNextResultQuestion;
}

export class ShowPreviousResultQuestion implements Action<ExaminationActionType> {
  readonly type = ExaminationActionType.ShowPreviousResultQuestion;
}

export class SetAnswer implements Action<ExaminationActionType> {
  readonly type = ExaminationActionType.SetAnswer;
  constructor(public payload: { answer: Answer; questionId: string }) {}
}

export class ShowResultQuestion implements Action<ExaminationActionType> {
  readonly type = ExaminationActionType.ShowResultQuestion;
  constructor(public payload: { question: Question }) {}
}

export class ShowResult implements Action<ExaminationActionType> {
  readonly type = ExaminationActionType.ShowResult;
}

export class StopExamination implements Action<ExaminationActionType> {
  readonly type = ExaminationActionType.StopExamination;
}

export type ExaminationAction =
  | FetchExamination
  | FetchExaminationSuccess
  | FetchExaminationError
  | SelectNextQuestion
  | ShowNextResultQuestion
  | ShowPreviousResultQuestion
  | SetAnswer
  | StartExampleQuestion
  | StartExamination
  | ShowResultQuestion
  | ShowResult
  | StopExamination;
